/* LL Startseite, Kopf und Kollektion (Marian 2026-11-03). Ein Skript für alle drei Abschnitte, jeder Teil prüft, ob er gebraucht wird. */
(function () {
  if (window.__llsGeladen) return; window.__llsGeladen = true;
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Menü (Hamburger): schiebt sich von links herein (Klasse am Kopf-Abschnitt), Reiter für die Gruppen. */
  function menue(auf) {
    var m = document.querySelector('[data-lls-menue]'); if (!m) return;
    var wurzel = m.closest('.lls');
    wurzel.classList.toggle('lls-menue-offen', auf);
    m.setAttribute('aria-hidden', String(!auf)); if (auf) m.removeAttribute('inert'); else m.setAttribute('inert', '');
    document.documentElement.style.overflow = auf ? 'hidden' : '';
    if (auf) { var z = m.querySelector('.lls-m-zu'); if (z) setTimeout(function () { z.focus({ preventScroll: true }); }, 50); }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-lls-ham]') && !e.target.closest('[data-lls-zu]')) { menue(true); return; }
    if (e.target.closest('[data-lls-zu]')) { menue(false); return; }
    var rt = e.target.closest('[data-lls-reiter]');
    if (rt) {
      var nav = rt.closest('[data-lls-menue]'), n = rt.getAttribute('data-lls-reiter');
      [].forEach.call(nav.querySelectorAll('[data-lls-reiter]'), function (x) { x.setAttribute('aria-selected', String(x === rt)); });
      [].forEach.call(nav.querySelectorAll('[data-lls-tafel]'), function (x) { x.hidden = x.getAttribute('data-lls-tafel') !== n; });
      return;
    }
    /* „Jetzt personalisieren“: zufällig eines der Top-Produkte (Ziele im Kopf-Abschnitt), dort direkt zur Personalisierung. */
    var p = e.target.closest('a[href="#ll-personalisieren"]');
    if (p) {
      var ziele = (window.LLPersZiele || []).map(function (z) { return String(z).trim(); }).filter(Boolean);
      if (!ziele.length) return;
      e.preventDefault();
      location.href = ziele[Math.floor(Math.random() * ziele.length)] + '#personalisieren';
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') menue(false); });

  /* Auf der Produktseite nach „Jetzt personalisieren“ zur Personalisierung scrollen. */
  if (location.hash === '#personalisieren') {
    var versuche = 0;
    (function suche() {
      var el = document.querySelector('ll-personalisierung, [data-ll-personalisierung], .ll-pers');
      if (el) { el.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'center' }); return; }
      if (++versuche < 20) setTimeout(suche, 250);
    })();
  }

  /* Zähler an der Tasche nachziehen, wenn sich der Warenkorb ändert. */
  function zaehler() {
    var z = document.querySelector('[data-lls-zahl]'); if (!z) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (k) {
      z.textContent = k.item_count; z.hidden = !k.item_count;
    }).catch(function () {});
  }
  ['cart:change', 'cart:refresh', 'variant:add', 'll:korb:geaendert'].forEach(function (n) { document.addEventListener(n, function () { setTimeout(zaehler, 150); }); });

  function start() {
    /* Hero-Karussell: Bildfolien 5,5 s, der Spot läuft immer komplett, erst danach geht es weiter (Marian 2026-11-03). */
    var hero = document.querySelector('[data-lls-hero]');
    if (hero && !hero.__an) {
      hero.__an = true;
      var f = [].slice.call(hero.querySelectorAll('.lls-folie')), st = [].slice.call(hero.querySelectorAll('.lls-striche button')), i = 0, t;
      var zeige = function (n) {
        i = (n + f.length) % f.length;
        f.forEach(function (x, j) {
          x.toggleAttribute('data-aktiv', j === i);
          var v = x.querySelector('video');
          if (v) { if (j === i) { v.currentTime = 0; v.play().catch(function () {}); } else v.pause(); }
        });
        st.forEach(function (b, j) { b.setAttribute('aria-selected', String(j === i)); });
        clearTimeout(t);
        if (!still && f.length > 1 && !f[i].querySelector('[data-spot]')) t = setTimeout(function () { zeige(i + 1); }, 5500);
      };
      f.forEach(function (x, j) { var v = x.querySelector('[data-spot]'); if (v) v.addEventListener('ended', function () { if (i === j) zeige(j + 1); }); });
      st.forEach(function (b, j) { b.onclick = function () { zeige(j); }; });
      if (f.length) zeige(0);
    }
    /* Farb-Schieber: schwingt von selbst, bis man selbst zieht. Am Handy (Marian 2026-11-03: „ruckelt, wenn man mit dem
       Finger schiebt“): Touch selbst auswerten. Waagerecht = Schieber (dann darf die Produktreihe nicht mitscrollen),
       senkrecht = Seite scrollt normal. Gezeichnet wird je Bildschirm-Frame höchstens einmal. */
    [].forEach.call(document.querySelectorAll('[data-lls-vgl]'), function (v) {
      if (v.__an) return; v.__an = true;
      var an = true, w = 0, ziel = null, plan = false, r = null;
      var zeichne = function () { plan = false; if (ziel != null) v.style.setProperty('--x', Math.max(3, Math.min(97, ziel)) + '%'); };
      var setz = function (x) { ziel = x; if (!plan) { plan = true; requestAnimationFrame(zeichne); } };
      var aus = function (clientX) { return (clientX - r.left) / r.width * 100; };
      /* Maus und Stift */
      var zieh = false;
      v.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') return; zieh = true; an = false; r = v.getBoundingClientRect(); setz(aus(e.clientX)); e.preventDefault(); });
      window.addEventListener('pointermove', function (e) { if (zieh) setz(aus(e.clientX)); });
      window.addEventListener('pointerup', function () { zieh = false; });
      /* Finger */
      var sx = 0, sy = 0, modus = null;
      v.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; modus = null; an = false; r = v.getBoundingClientRect(); }, { passive: true });
      v.addEventListener('touchmove', function (e) {
        var t = e.touches[0], dx = t.clientX - sx, dy = t.clientY - sy;
        if (!modus) { if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return; modus = Math.abs(dx) > Math.abs(dy) ? 'schieben' : 'scrollen'; }
        if (modus !== 'schieben') return;
        e.preventDefault(); e.stopPropagation();
        setz(aus(t.clientX));
      }, { passive: false });
      v.addEventListener('touchend', function () { modus = null; }, { passive: true });
      v.addEventListener('click', function (e) { e.preventDefault(); });
      if (!still) (function lauf() { if (!an) return; w += 0.012; setz(50 + 38 * Math.sin(w)); requestAnimationFrame(lauf); })();
    });
    /* Newsletter im Fuß: an Shopify senden, ohne die Seite zu verlassen. */
    [].forEach.call(document.querySelectorAll('form.lls-nl'), function (fm) {
      if (fm.__an) return; fm.__an = true;
      fm.addEventListener('submit', function (e) {
        e.preventDefault();
        fetch(fm.action, { method: 'POST', body: new FormData(fm) }).finally(function () {
          fm.outerHTML = '<p class="lls-nl-ok">Danke! Du hörst von uns, sobald es Neues gibt.</p>';
        });
      });
    });
    if (window.LLKollektion) window.LLKollektion();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
